import { Box } from "@mui/material";
import { FullScreenBackground } from "@app/components/FullScreenBackground";
import { CarFooter } from "@app/components/Footer";
import { useNavigate } from "react-router-dom";
import { LoginTransparentBox } from "@app/pages/login/LoginComponents";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { useCommonBillingBillingCheckStatusCreateQuery } from "@app/api/carApi.generated";
import { useEffect } from "react";
import { rootPages } from "@app/const/route.const";
import { useAppDispatch } from "@app/hooks/useAppDispatch";
import { api } from "@app/api/carApi.manual";

export const PaymentCompletePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { isLoading, data } = useCommonBillingBillingCheckStatusCreateQuery();

  useEffect(() => {
    dispatch(api.util.invalidateTags(["BillingCheckStatus"]));
  }, [dispatch]);

  useEffect(() => {
    if (isLoading || !data) {
      return;
    }

    if (data.subscription_status === "active") {
      navigate(rootPages.home);
    } else {
      navigate(rootPages.payment);
    }
  }, [isLoading, data, navigate]);

  return (
    <FullScreenBackground
      sx={{
        alignItems: "center",
        justifyContent: "center",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          m: "auto",
          py: 2,
          display: "flex",
          flexDirection: "column",
          justifyItems: "center",
        }}
      >
        <LoginTransparentBox sx={{ px: "77px", py: "54px", minWidth: 680 }}>
          <TablePlaceHolder isLoading={isLoading} rows={5} />
        </LoginTransparentBox>
        <CarFooter
          sx={{ mt: 1.5, alignSelf: "center" }}
          isWhite
          isCopyrightOnly
          hasPrivacyPolicy
        />
      </Box>
    </FullScreenBackground>
  );
};
